import React, { useContext } from "react";
import t from "module/translations";
import TrainingCustomContext from "module/trainingCustom/context/TrainingCustomContext";
import { TrainingCustomInterface } from "module/trainingCustom/types";
import XLabelField from "component/labelField/XLabelField";

const TrainingCustomReportingNumberFieldContainer: React.FC = () => {
  const { entity } = useContext(TrainingCustomContext);
  const { reportingNumber } = entity as TrainingCustomInterface;

  return (
    <XLabelField
      {...{
        caption: t.competencyManagement.trainingCustom.reportingNumberText,
        label: reportingNumber,
      }}
    />
  );
};

export default React.memo(TrainingCustomReportingNumberFieldContainer);
